export const FETCH_REPARACIONES_REQUEST = "FETCH_REPARACIONES_REQUEST";
export const FETCH_REPARACIONES_SUCCESS = "FETCH_REPARACIONES_SUCCESS";
export const FETCH_REPARACIONES_FAILURE = "FETCH_REPARACIONES_FAILURE";
